import React, { useEffect, useState } from 'react'
import { Button, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSave } from '@fortawesome/free-solid-svg-icons';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Shared
import ModeloEnvioEmail from '../../../Shared/ModeloEnvioEmail';

//Context
import { useAuth } from '../../../../context/auth';

//API
import variaveisSistema_api from '../../../../api/variaveisSistema_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import MainCard from '../../../../components/MainCard';
import emailLote_api from '../../../../api/emailLote_api';

export default function EnviarCobrancaEmLote({ 
    handleReturn,  
    envioLoteEmail,
    setEnvioLoteEmail,
    listaEnviarCobranca = [], 
    setListaEnviarCobranca,
    setErrors, 
    errors 
}) {
    const { setLoading } = useAuth();
    //State de lista de Variaveis do sistema
    const [listaVariaveisSistema, setListaVariaveisSistema] = useState([]);

    //State para visibilidade do modal
    const [isModalListaVariaveis, setIsModalListaVariaveis] = useState(false);

    //Cabeçalhos da lista de consulta infração
    const headers = [ 
        { objectValue: "numeroInfracao", value: "NÚMERO INFRAÇÃO", col: "12" },
        { objectValue: "dataInfracao", value: "DATA INFRAÇÃO", col: "12" },
        { objectValue: "nomeInfrator", value: "NOME INFRATOR", col: "12" },
        { objectValue: "emailInfrator", value: "EMAIL INFRATOR", col: "12" }, 
    ];

    //Estado de controle dos campos obrigatorios 
    const campos = [ 
        objCampo({ name: "conteudo", required: true }),
        objCampo({ name: "assunto", required: true }),
    ];

     //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _envioLoteEmail = {
            ...envioLoteEmail,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_envioLoteEmail, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });
    
        setEnvioLoteEmail(_envioLoteEmail);
    }

    async function handleEnviarLoteEmailCobrancas() {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(envioLoteEmail, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true; 

        setLoading(true);
        try{
            await emailLote_api.Insert(envioLoteEmail);
            showMessage("Sucesso", "Sucesso ao enviar cobranças em lote.", "success", () => {
                setEnvioLoteEmail((prev) => ({
                    ...prev,
                    infracaoIds: [],
                    assunto: "",
                    conteudo: "",
                    imagensConteudo: []
                }));
                setListaEnviarCobranca([]);
                handleReturn();
            });
        }catch(error) {
            showMessage("Erro", error.message, "error", null);
        }finally {
            setLoading(false);
        }
    }

    async function loadListaVariaveisSistema() {
        setLoading(true)
        try{
            const { data } = await variaveisSistema_api.getList();
            if(!!data && data.length > 0)
                setListaVariaveisSistema(data.filter(x => x.tipo === "Infração"));
            else 
                setListaVariaveisSistema([]);
        }catch(error) {
            showMessage("Erro", error.message, "error", null);
        }finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadListaVariaveisSistema();
    }, []);

    return (
        <MainCard>
            <ModeloEnvioEmail
                errors={errors}
                isModalListaVariaveis={isModalListaVariaveis}
                setIsModalListaVariaveis={setIsModalListaVariaveis}
                listaVariaveisSistema={listaVariaveisSistema}
                modeloEmail={envioLoteEmail}
                onChange={onChange}
                setModeloEmail={setEnvioLoteEmail} 
                title='Dados do e-mail'
            />  

            <div className='d-flex justify-content-center gap-3 my-2'> 
                <div>
                    <Button
                        color='primary'
                        className='text-white fw-bold w-100 mt-2'
                        onClick={() => handleReturn()}
                    >
                        <FontAwesomeIcon icon={faClose} /> Cancelar
                    </Button> 
                </div> 
                <div>
                    <Button
                        color='warning'
                        className='text-white fw-bold w-100 mt-2'
                        onClick={handleEnviarLoteEmailCobrancas}
                    >
                        <FontAwesomeIcon icon={faSave} /> Confirmar
                    </Button> 
                </div>
            </div>

            {listaEnviarCobranca.length > 0 &&
                <Row className='mt-2'>
                    <TabelaListagem
                        actions={[]}
                        title={`Lista de infrações`}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers}
                        items={listaEnviarCobranca}
                    />
                </Row>
            }
        </MainCard>
    )
}
